import firebase from "@firebase/app"
import config from '../../firebase-config.json';

// ----------------------------- o

export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();